module.exports = __webpack_public_path__ + "static/1st_floor_2-fcbf40f7d41fde7416a3950c735b8881.jpg";